export const propRules = {
  rules: {
    heading: "Unterkunftsregeln",
    subheading:
      "Legen Sie die Check-in- und Check-out-Zeiten fest, die dem Gast beim Check-in mitgeteilt werden.",
    cloneTitleNoun: "Zeiten",
    cloneItemNoun: "die Zeiten",
    bulkNoticePrefix:
      "Diese Änderung gilt für die {count} Unterkünfte, die verknüpft sind mit",
    checkinLabel: "Check-in",
    checkoutLabel: "Check-out",
    defaultCheckin: "Standard 15:00",
    defaultCheckout: "Standard 12:00",
    saving: "Wird gespeichert…",
    save: "Speichern",
    toasts: {
      loadError: "Die Daten des Inserats konnten nicht geladen werden.",
      bulkApplied: "Regeln auf {count} Unterkünfte angewendet",
      saveSuccess: "Regeln erfolgreich gespeichert",
      bulkPartialError: "Einige Unterkünfte konnten nicht aktualisiert werden",
      saveError: "Fehler beim Speichern der Regeln",
    },
  },
  services: {
    cloneTitleNoun: "Ausstattung und Annehmlichkeiten",
    cloneItemNoun: "die Ausstattung und Annehmlichkeiten",
    toasts: {
      saveSuccess: "Ausstattung erfolgreich gespeichert",
      saveError: "Fehler beim Speichern der Ausstattung",
    },
  },
  maintenance: {
    title: "Wartung der Unterkunft",
    scopeProperty: "Gesamte Unterkunft",
    scopeUnits: "Bestimmte Einheiten",
    selectUnits: "Einheiten auswählen",
    dateFrom: "Von",
    dateTo: "Bis",
    closeArrivals: "Anreisen sperren (CTA)",
    closeDepartures: "Abreisen sperren (CTD)",
    applying: "Wird angewendet...",
    apply: "Wartung anwenden",
    removing: "Wird entfernt...",
    remove: "Wartung entfernen",
    toasts: {
      rangeScopeRequired:
        "Vervollständigen Sie den Zeitraum und den Geltungsbereich (Einheiten oder Unterkunft).",
      applied: "Wartung angewendet.",
      applyError: "Fehler beim Anwenden der Wartung.",
      removed: "Wartung entfernt.",
      removeError: "Fehler beim Entfernen der Wartung.",
    },
  },
  propMaintenance: {
    title: "Wartung der Unterkunft",
    scopeProperty: "Gesamte Unterkunft",
    scopeUnits: "Bestimmte Einheiten",
    selectUnits: "Einheiten auswählen",
    dateFrom: "Von",
    dateTo: "Bis",
    closeArrivals: "Anreisen sperren (CTA)",
    closeDepartures: "Abreisen sperren (CTD)",
    applying: "Wird angewendet...",
    apply: "Wartung anwenden",
    removing: "Wird entfernt...",
    remove: "Wartung entfernen",
    toasts: {
      rangeScopeRequired:
        "Vervollständigen Sie den Zeitraum und den Geltungsbereich (Einheiten oder Unterkunft).",
      applied: "Wartung angewendet.",
      applyError: "Fehler beim Anwenden der Wartung.",
      removed: "Wartung entfernt.",
      removeError: "Fehler beim Entfernen der Wartung.",
    },
  },
};
